
import { useState } from 'react';
import { Link } from 'react-router-dom';

const RouenNewsSection = () => {
  const [language, setLanguage] = useState('ar');

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    if (language === 'ar') {
      return date.toLocaleDateString('ar-SA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const news = [
    {
      id: 1,
      titleFr: "Nouveau centre culturel maghrébin à Rouen",
      titleAr: "مركز ثقافي مغاربي جديد في روان",
      contentFr: "Ouverture prochaine d'un centre culturel dédié à la communauté maghrébine dans le quartier Grammont.",
      contentAr: "افتتاح قريب لمركز ثقافي مخصص للجالية المغاربية في حي غرامون.",
      date: "2024-01-15",
      category: "Culture",
      categoryAr: "ثقافة",
      image: "https://public.readdy.ai/ai/img_res/b10fbbc18a2e61a724619e5c8421124f.jpg"
    },
    {
      id: 2,
      titleFr: "Formation professionnelle pour la communauté",
      titleAr: "تدريب مهني للجالية",
      contentFr: "Lancement d'un programme de formation en mécanique automobile et réparation domiciliaire.",
      contentAr: "إطلاق برنامج تدريبي في ميكانيكا السيارات والإصلاح المنزلي.",
      date: "2024-01-12",
      category: "Formation",
      categoryAr: "تدريب",
      image: "https://readdy.ai/api/search-image?query=Professional%20training%20workshop%20in%20Rouen%20with%20North%20African%20trainees%20learning%20automotive%20mechanics%20and%20home%20repair%20skills%2C%20modern%20equipment%2C%20instructor%20demonstrating%20techniques%2C%20educational%20environment&width=600&height=400&seq=news-training&orientation=landscape"
    },
    {
      id: 3,
      titleFr: "Marché solidaire hebdomadaire",
      titleAr: "سوق تضامني أسبوعي",
      contentFr: "Tous les samedis, marché solidaire place du Vieux-Marché avec produits du Maghreb.",
      contentAr: "كل يوم سبت، سوق تضامني في ساحة السوق القديم مع منتجات من المغرب العربي.",
      date: "2024-01-10",
      category: "Solidarité",
      categoryAr: "تضامن",
      image: "https://readdy.ai/api/search-image?query=Weekly%20solidarity%20market%20in%20Rouen%20old%20market%20square%20with%20Maghreb%20products%2C%20North%20African%20vendors%20selling%20traditional%20foods%20and%20crafts%2C%20community%20gathering%2C%20colorful%20market%20stalls%2C%20cultural%20exchange&width=600&height=400&seq=news-market&orientation=landscape"
    },
    {
      id: 4,
      titleFr: "Aide administrative gratuite",
      titleAr: "مساعدة إدارية مجانية",
      contentFr: "Permanence gratuite tous les mardis pour l'aide aux démarches administratives.",
      contentAr: "خدمة مجانية كل يوم ثلاثاء للمساعدة في الإجراءات الإدارية.",
      date: "2024-01-08",
      category: "Services",
      categoryAr: "خدمات",
      image: "https://readdy.ai/api/search-image?query=Free%20administrative%20help%20office%20in%20Rouen%20with%20North%20African%20community%20volunteers%20helping%20people%20with%20paperwork%20and%20official%20documents%2C%20professional%20setting%2C%20translation%20services%2C%20helpful%20atmosphere&width=600&height=400&seq=news-admin&orientation=landscape"
    },
    {
      id: 5,
      titleFr: "Fête de l'Aïd communautaire",
      titleAr: "احتفال العيد المجتمعي",
      contentFr: "Grande célébration de l'Aïd au parc Grammont avec repas partagé et animations.",
      contentAr: "احتفال كبير بالعيد في حديقة غرامون مع وجبة مشتركة وأنشطة ترفيهية.",
      date: "2024-01-05",
      category: "Événement",
      categoryAr: "حدث",
      image: "https://readdy.ai/api/search-image?query=Community%20Eid%20celebration%20in%20Grammont%20park%20Rouen%20with%20North%20African%20families%20sharing%20traditional%20meal%2C%20children%20playing%2C%20festive%20decorations%2C%20cultural%20celebration%2C%20joyful%20atmosphere%2C%20community%20gathering&width=600&height=400&seq=news-eid&orientation=landscape"
    },
    {
      id: 6,
      titleFr: "Cours d'arabe pour enfants",
      titleAr: "دروس العربية للأطفال",
      contentFr: "Inscription ouverte pour les cours d'arabe destinés aux enfants de la communauté.",
      contentAr: "التسجيل مفتوح لدروس اللغة العربية المخصصة لأطفال الجالية.",
      date: "2024-01-03",
      category: "Éducation",
      categoryAr: "تعليم",
      image: "https://readdy.ai/api/search-image?query=Arabic%20language%20classroom%20in%20Rouen%20with%20North%20African%20children%20learning%20Arabic%20writing%20and%20reading%2C%20teacher%20at%20blackboard%2C%20educational%20materials%2C%20bright%20classroom%20environment%2C%20cultural%20education&width=600&height=400&seq=news-education&orientation=landscape"
    }
  ];

  const content = {
    fr: {
      title: "Actualités de Rouen",
      subtitle: "Dernières nouvelles de notre communauté",
      readMore: "Lire la suite",
      allNews: "Toutes les actualités"
    },
    ar: {
      title: "أخبار روان",
      subtitle: "آخر أخبار مجتمعنا",
      readMore: "اقرأ المزيد",
      allNews: "جميع الأخبار"
    }
  };

  const currentContent = content[language as keyof typeof content];
  const isRTL = language === 'ar';

  // Préparer les actualités avec les bonnes propriétés selon la langue
  const currentNews = news.map((item, index) => ({
    id: item.id,
    title: language === 'ar' ? item.titleAr : item.titleFr,
    excerpt: language === 'ar' ? item.contentAr : item.contentFr,
    category: language === 'ar' ? item.categoryAr : item.category,
    categoryColor: 'bg-emerald-600',
    date: formatDate(item.date),
    author: language === 'ar' ? 'فريق ولد بلادي' : 'Équipe Wald Bladi',
    views: Math.floor(Math.random() * 500) + 100,
    image: item.image
  }));

  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          {/* Language Toggle */}
          <div className="flex justify-center mb-8">
            <div className="flex items-center bg-white rounded-lg p-1 shadow-lg">
              <button
                onClick={() => setLanguage('fr')}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-all cursor-pointer whitespace-nowrap ${
                  language === 'fr' 
                    ? 'bg-emerald-600 text-white shadow-lg' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Français
              </button>
              <button
                onClick={() => setLanguage('ar')}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-all cursor-pointer whitespace-nowrap ${
                  language === 'ar' 
                    ? 'bg-emerald-600 text-white shadow-lg' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                العربية
              </button>
            </div>
          </div>

          <div className={isRTL ? 'text-right' : 'text-left'} dir={isRTL ? 'rtl' : 'ltr'}>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {currentContent.title}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {currentContent.subtitle}
            </p>
          </div>
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {currentNews.map((newsItem, index) => (
            <article key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group">
              <div className="relative overflow-hidden">
                <img
                  src={newsItem.image}
                  alt={newsItem.title}
                  className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className={`px-3 py-1 text-xs font-semibold rounded-full ${newsItem.categoryColor} text-white`}>
                    {newsItem.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <i className="ri-calendar-line mr-2"></i>
                  <span>{newsItem.date}</span>
                  <span className="mx-2">•</span>
                  <i className="ri-user-line mr-1"></i>
                  <span>{newsItem.author}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                  {newsItem.title}
                </h3>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {newsItem.excerpt}
                </p>
                
                <div className="flex items-center justify-between">
                  <Link
                    to={`/news/${index + 1}`}
                    className="inline-flex items-center px-4 py-2 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <span>{currentContent.readMore}</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                  
                  <div className="flex items-center text-gray-400">
                    <i className="ri-eye-line mr-1"></i>
                    <span className="text-sm">{newsItem.views}</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <button className="bg-emerald-600 text-white px-8 py-4 rounded-xl hover:bg-emerald-700 transition-colors font-semibold text-lg cursor-pointer whitespace-nowrap shadow-lg inline-flex items-center">
            <i className="ri-newspaper-line mr-3"></i>
            {currentContent.allNews}
          </button>
        </div>
      </div>
    </section>
  );
};

export default RouenNewsSection;
